module.exports = "pegasus/assets/grayrect-twitter.png";